import {
  defineComponent,
} from 'vue';

export default defineComponent({
  delimiters: ['${', '}'],
  props: {
    sku: {
      type: String,
      default: null,
    },
  },
  computed: {
    surcharge() {
      return this.$store.getters.variantSurcharge(this.sku);
    },
    surchargeRaw(): number|null {
      return this.$store.getters.variantSurchargeRaw(this.sku);
    },
  },
  template: '#t-product-surcharge',
});
